import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { cleanList } from '../../commons/cleanList';
import { buildDrupalImage } from '../Image';

export function mapSpecialistSlide(specialist: SpecialistSlideFragment) {
  return {
    name: specialist.title,
    gender: specialist.gender as 'male' | 'female',
    Image: specialist.imagePortrait
      ? buildDrupalImage(specialist.imagePortrait, 'content')
      : undefined,
    Link: buildLink({ href: specialist.path }),
  };
}

export function mapSpecialistSlider(
  input: SpecialistSliderFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'SliderSpecialist'> {
  return {
    key: 'SliderSpecialist',
    input: {
      title: input.title,
      specialists:
        input.specialists?.filter(cleanList).map(mapSpecialistSlide) || [],
    },
  };
}
